import onCumulativeLayoutShift from './onCumulativeLayoutShift';
import onDomComplete from './onDomComplete';
import onDomInteractive from './onDomInteractive';
import onDomLoading from './onDomLoading';
import onFirstContentfulPaint from './onFirstContentfulPaint';
import onFirstInputDelay from './onFirstInputDelay';
import onLargestContentfulPaint from './onLargestContentfulPaint';
import onTimeToFirstByte from './onTimeToFirstByte';
import onWindowOnLoad from './onWindowOnLoad';
import onBenchmark from './onBenchmark';

const reportMetrics = report => {
  const fullResponse = (name, unit) => value => report(name, value, unit);
  onCumulativeLayoutShift(fullResponse('cumulative-layout-shift', ''));
  onDomComplete(fullResponse('dom-complete', 'ms'));
  onDomInteractive(fullResponse('dom-interactive', 'ms'));
  onDomLoading(fullResponse('dom-loading', 'ms'));
  onFirstContentfulPaint(fullResponse('first-contentful-paint', 'ms'));
  onFirstInputDelay(fullResponse('first-input-delay', 'ms'));
  onLargestContentfulPaint(fullResponse('largest-contentful-paint', 'ms'));
  onTimeToFirstByte(fullResponse('time-to-first-byte', 'ms'));
  onWindowOnLoad(fullResponse('window-on-load', 'ms'));
  onBenchmark(fullResponse('cpu-benchmark', 'ops'));
};

export default reportMetrics;
